<template>
  <div :class="['contact-form container-fluid pt-large pb-small bg-color', className]">
    <div class="wrapper-fixed">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-8 mb-2">
          <div :id="sectionID" class="section-name">Contact Us</div>
          <h2 class="h1-xl header-gradient d-inline-block">Let’s Work Together</h2>
          <p>Please Fill out the contact form below, or give us a call at <a href="tel:1-888-555-1212" class="xl-type weight-bold">1-888-555-1212</a></p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-8">
          <form>
            <div class="form-floating mb-3">
              <input type="text" class="form-control lg-type" id="contact-first-name" placeholder="First Name">
              <label for="contact-first-name" class="ps-0">First Name</label>
            </div>
            <div class="form-floating mb-3">
              <input type="text" class="form-control lg-type" id="contact-last-name" placeholder="Last Name">
              <label for="contact-last-name" class="ps-0">Last Name</label>
            </div>
            <div class="form-floating mb-3">
              <input type="email" class="form-control lg-type" id="contact-email" placeholder="name@example.com">
              <label for="contact-email" class="ps-0">Email Address</label>
            </div>
            <div class="form-floating mb-3">
              <textarea class="form-control lg-type" placeholder="Leave a comment here..." id="contact-message"></textarea>
              <label for="contact-message">Message</label>
            </div>
            <div>
              <button class="btn btn-lg btn-primary">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockContactForm',
  props: {
    className: [String, Array],
    sectionID: String,
  },
};
</script>